import React, { useEffect, useState } from "react";
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import useAuth from '../../hooks/useAuth';
import QuoteCustomerTab from "./tabs/quote-customer";
import PreQuoteTab from "./tabs/pre-quote";
import QuoteHistoryTab from "./tabs/quote-history";
import UserServices from "../../services/UserServices";
import QuoteMeService from "../../services/QuoteMeService";
import './quote-me.css';

const QuoteMePage = () => {
    const { user, updateCustomers } = useAuth();
    const [activeTab, setActiveTab] = useState('quote-customer');
    const [showSpinner, setShowSpinner] = useState(0);
    const [showLoader, setShowLoader] = useState(1);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [multipliers, setMultipliers] = useState([]);
    const [showShareModal, setShowShareModal] = useState(false);
    const [customerLoaded, setCustomerLoaded] = useState(false);

    const userServices = new UserServices();
    const quoteMeService = new QuoteMeService();

    useEffect(() => {
        seo({
            title: SITE_TITLE + ' || Quote Me',
            metaDescription: '',
        });
    }, [user]);

    return (
        <main className="techtop-middle-div">
            <section className="techtop-quote-section pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="techtop-default-title2">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h1 className="m-0 dark-color1">Quote Me</h1>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <h1 className="m-0 dark-color1">{user.name}</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-4" id="techtop-news-tabs">
                                    {/* Tabs */}
                                    <ul className="nav nav-tabs">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'quote-customer' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('quote-customer')}
                                            >
                                                Quote Customer
                                            </button>
                                        </li>

                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'pre-quote' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('pre-quote')}
                                            >
                                                Pre-Quote
                                            </button>
                                        </li>

                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'quote-history' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('quote-history')}
                                            >
                                                Quote History
                                            </button>
                                        </li>
                                    </ul>
                                    {/* Tab Content */}
                                    <div className="tab-content mt-3">
                                        <QuoteCustomerTab
                                            key={activeTab === 'quote-customer' ? 'quote-customer' : ''}
                                            active={activeTab === 'quote-customer'}
                                        />

                                        <PreQuoteTab
                                            key={activeTab === 'pre-quote' ? 'pre-quote' : ''}
                                            active={activeTab === 'pre-quote'}
                                        />

                                        <QuoteHistoryTab
                                            key={activeTab === 'quote-history' ? 'quote-history' : ''}
                                            active={activeTab === 'quote-history'}
                                        />
                                        {/* <QuoteCustomerTab 
                                            active={activeTab === 'quote-customer'}
                                        />
                                        <PreQuoteTab 
                                            active={activeTab === 'pre-quote'}
                                        />
                                        <QuoteHistoryTab 
                                            active={activeTab === 'quote-history'}
                                        /> */}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};
export default QuoteMePage;